/**
 * Image compression utility
 * Resizes and compresses images before upload to reduce DB/storage load.
 * Returns both a Blob (for Supabase Storage upload) and a dataURL (for preview).
 */
export async function compressImage(file, maxWidth = 800, quality = 0.7) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = reject;
    reader.onload = (e) => {
      const img = new Image();
      img.onerror = () => reject(new Error('Failed to load image'));
      img.onload = () => {
        const canvas = document.createElement('canvas');
        let w = img.width, h = img.height;
        if (w > maxWidth) {
          h = Math.round((h * maxWidth) / w);
          w = maxWidth;
        }
        canvas.width = w;
        canvas.height = h;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, w, h);

        canvas.toBlob(
          (blob) => {
            const dataUrl = canvas.toDataURL('image/jpeg', quality);
            resolve({ blob, dataUrl, width: w, height: h, sizeKB: Math.round(blob.size / 1024) });
          },
          'image/jpeg',
          quality
        );
      };
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
  });
}

/**
 * Compress multiple files. Returns array of { blob, dataUrl, filename }.
 */
export async function compressImages(files, maxWidth = 800, quality = 0.7) {
  const results = [];
  for (const file of files) {
    try {
      const { blob, dataUrl } = await compressImage(file, maxWidth, quality);
      results.push({ blob, dataUrl, filename: file.name });
    } catch (err) {
      console.error('Compression failed for', file.name, err);
    }
  }
  return results;
}
